import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["paginationOption", "sortOption", "siteFilterLabel", "siteFilterOption", "siteFilterField"]
  }

  static get values() {
    return {
      query: String,
      updateUrl: {
        type: Boolean,
        default: true,
      }
    };
  }

  connect() {
    this.setPaginationOptionLinks()
    this.setSortOptionLinks()
  }

  rendered() {
    $('.selectpicker').selectpicker({
      noneSelectedText: ''
    });
    this.rendered();
    this.manageFilterPills()
  }

  manageFilterPills(){
    let hasChanges = false;
    $('.pill-input').on('change.bs.select', function() {
      hasChanges = true;
    });

    // submit filters when dropdowns are hidden
    $('.pill-input').on('hidden.bs.select', function(e) {
      if (hasChanges){
        e.preventDefault;
        this.form.requestSubmit();
      }
      hasChanges = false;
    });
    
    // submit filter when user hits enter in a search
    $('.search').on('keyup', function(e) {
      if(e.keyCode == 13) {
        e.preventDefault();
        this.form.requestSubmit();
      }
    })

    // submit filter when search loses focus
    $('.search').on('focusout', function(e){
      if(e.currentTarget.value != '') {
        e.preventDefault();
        this.form.requestSubmit();
      }
    })
  }

  setPaginationOptionLinks(){
    let params = new URLSearchParams(this.queryValue);
    let url = new URL(window.location.href);
    this.paginationOptionTargets.forEach((element)=>{
      let option = element.dataset.option
      params.set("per_page", option)
      params.set("page", 1)
      url.search = params.toString();
      element.href = url.href
    })
  }

  setSortOptionLinks(){
    let params = new URLSearchParams(this.queryValue);
    let url = new URL(window.location.href);
    this.sortOptionTargets.forEach((element)=>{
      let option = element.dataset.option
      params.set("sort_type", option)
      url.search = params.toString();
      element.href = url.href
    })
  }

  loadingAnimation(){
    document.getElementById('catalog-content').ariaBusy = true
  }

  selectSite(e){
    this.siteFilterFieldTarget.value = e.target.dataset.siteId
    $(this.siteFilterLabelTarget).text(`Site: ${e.target.dataset.siteLabel}`)
  }
}
